export const CRUD_STATES = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
  DELETE: 'DELETE',
  UPDATE: 'UPDATE',
};

// Video page list keys
export const RELATED_VIDEO_COLLECTION_LIST = 'RELATED_VIDEO_COLLECTION_LIST';
export const RELATED_COLLECTION_LIST = 'RELATED_COLLECTION_LIST';
export const INITIAL_RELATED_COLLECTION_LIST =
  'INITIAL_RELATED_COLLECTION_LIST';

// Collection page list keys
export const VIDEO_COLLECTION_SUGGESTION = 'VIDEO_COLLECTION_SUGGESTION';
export const PAGE_COLLECTION_VIDEO_LIST = 'PAGE_COLLECTION_VIDEO_LIST';
export const PAGE_COLLECTION_RELATED_VIDEO_COLLECTION_LIST =
  'PAGE_COLLECTION_RELATED_VIDEO_COLLECTION_LIST';
export const PAGE_COLLECTION_VIDEO_COLLECTION_SUGGESTION =
  'PAGE_COLLECTION_VIDEO_COLLECTION_SUGGESTION';
